var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1920,
    height: 843,
    viewBox: "0 0 1920 843",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.b{fill:#fff;}.a{stroke:#707070;}.c{clip-path:url(#a);}.d{opacity:0.11;clip-path:url(#b);}.e{fill:none;stroke:#1f5ca9;stroke-miterlimit:4.001;stroke-width:0.5px;}.f{fill:url(#c);}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 1920,
    height: 843
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M11.993,11.4,4149.961-8.167,4129.45,4294.4-8.518,4313.967Z",
    transform: "translate(0)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 0.332,
    y1: -0.179,
    x2: 1.01,
    y2: 0.893,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0.929
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "c"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -1612)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "d",
    transform: "matrix(0.375, -0.927, 0.927, 0.375, -960.34, 3436.449)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.998, 0.07, -0.07, -0.998, 8642.561, 4115.45)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M0,0C321.252,353.587,1753.461,1325.58,2258.231,872.967c638.43-572.457,1859.283-350.709,2309.842,1270.125S6635.3,4436.129,7507.009,4571.6",
    transform: "translate(905.509 -1.556)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M0,0C290.305,404.38,1742.371,1349.323,2246.013,895.594,2886.2,318.267,4171.476,493.2,4622.04,2114.032s1972.439,2341,2844.145,2476.476",
    transform: "translate(888.957 29)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M0,0C259.354,455.172,1731.276,1373.072,2233.792,918.221,2875.726,336.023,4225.438,464.139,4676,2084.972S6553.651,4473.95,7425.362,4609.423",
    transform: "translate(872.409 59.551)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M0,0C228.406,505.968,1720.186,1396.824,2221.574,940.852,2865.259,353.784,4279.4,435.079,4729.965,2055.912S6512.832,4492.864,7384.539,4628.337",
    transform: "translate(855.856 90.104)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M0,0C197.451,556.76,1709.091,1420.569,2209.356,963.48c645.435-591.942,2124.008-557.46,2574.566,1063.373S6472.006,4511.775,7343.711,4647.248",
    transform: "translate(839.308 120.659)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M0,0C166.5,607.553,1698,1444.322,2197.138,986.107,2844.325,389.3,4387.331,376.96,4837.891,1997.793s1593.292,2532.9,2465,2668.37",
    transform: "translate(822.756 151.211)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M0,0C135.552,658.349,1686.906,1468.07,2184.917,1008.739c648.937-601.684,2256.374-660.838,2706.937,960S6390.354,4549.6,7262.064,4685.072",
    transform: "translate(806.208 181.762)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M0,0C104.6,709.138,1675.816,1491.818,2172.7,1031.362c650.687-606.55,2322.557-712.521,2773.117,908.312s1403.719,2628.838,2275.425,2764.31",
    transform: "translate(789.655 212.318)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M0,0C73.649,759.934,1664.718,1515.567,2160.477,1053.993c652.441-611.425,2388.743-764.212,2839.3,856.622S6308.708,4587.426,7180.414,4722.9",
    transform: "translate(773.107 242.87)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M0,0C42.7,810.726,1653.627,1539.315,2148.259,1076.621c654.192-616.291,2454.923-815.9,2905.483,804.934s1214.143,2724.787,2085.85,2860.259",
    transform: "translate(756.555 273.421)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M0,0C11.75,861.518,1642.532,1563.064,2136.037,1099.248,2791.98,478.082,4657.145,231.662,5107.7,1852.491S6227.057,4625.252,7098.768,4760.724",
    transform: "translate(740.007 303.978)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M.14,0c-19.2,912.315,1632.382,1587.791,2123.82,1121.88,658.956-624.73,2587.288-919.278,3037.852,701.556s1024.568,2820.731,1896.274,2956.2",
    transform: "translate(723.315 334.529)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M1.033,0C-49.12,963.105,1622.371,1611.584,2112.631,1144.5c660.778-629.533,2653.472-970.964,3104.031,649.87s929.781,2868.7,1801.487,3004.174",
    transform: "translate(705.874 365.082)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M2.7,0C-78.4,1013.9,1612.991,1635.367,2102.08,1167.129c662.6-634.344,2719.658-1022.651,3170.217,598.178s834.991,2916.675,1706.7,3052.148",
    transform: "translate(687.654 395.641)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M5.086-.009C-106.965,1064.682,1604.317,1659.145,2092.245,1189.752c664.407-639.16,2785.837-1074.337,3236.4,546.5s740.2,2964.646,1611.911,3100.119",
    transform: "translate(668.72 426.197)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M8.143-.014c-143,1115.484,1588.174,1682.924,2074.941,1212.388,666.209-643.992,2852.022-1126.029,3302.582,494.8S6031.083,4719.8,6902.79,4855.272",
    transform: "translate(649.11 456.758)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M11.827-.02C-162.127,1166.256,1588.932,1706.677,2074.546,1235c668-648.829,2918.207-1177.72,3368.767,443.114s550.628,3060.595,1422.334,3196.068",
    transform: "translate(628.879 487.316)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M16.094-.028c-204.9,1217.073,1566.032,1730.463,2050.5,1257.647,669.79-653.67,2984.388-1229.4,3434.947,391.431s455.843,3108.565,1327.55,3244.033",
    transform: "translate(608.059 517.875)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M20.91-.036C-214.943,1267.829,1575.86,1754.179,2059.194,1280.238,2730.755,621.714,5109.761-.855,5560.321,1619.978s361.053,3156.536,1232.763,3292.008",
    transform: "translate(586.695 548.439)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M26.238-.045c-266.8,1318.657,1543.868,1777.968,2026.066,1302.9C2725.637,639.479,5169.053-29.925,5619.615,1590.909s266.268,3204.51,1137.974,3339.982",
    transform: "translate(564.815 579)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M32.05-.055C-265.706,1369.4,1564.828,1801.661,2045.894,1325.478,2720.99,657.23,5228.827-58.99,5679.386,1561.844S5850.867,4814.324,6722.574,4949.8",
    transform: "translate(542.455 609.561)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M38.313-.066C-290.39,1420.176,1560,1825.386,2039.94,1348.09,2716.791,674.971,5289.057-88.064,5739.617,1532.769s76.69,3300.454,948.4,3435.927",
    transform: "translate(519.639 640.128)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M45-.077C-314.65,1470.961,1555.585,1849.11,2034.409,1370.71c678.6-678,3315.3-1487.846,3765.862,132.988s-18.1,3348.429,853.611,3483.9",
    transform: "translate(496.4 670.691)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M52.1-.09C-338.5,1521.741,1551.575,1872.83,2029.284,1393.329c680.339-682.893,3381.483-1539.532,3832.043,81.3S5748.445,4871.03,6620.151,5006.5",
    transform: "translate(472.755 701.255)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M59.572-.1C-361.986,1572.521,1547.933,1896.54,2024.537,1415.94,2706.609,728.15,5472.2-175.28,5922.763,1445.554S5715.092,4889.922,6586.8,5025.4",
    transform: "translate(448.732 731.824)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M67.4-.116C-385.1,1623.3,1544.649,1920.245,2020.15,1438.557,2703.943,745.859,5534-204.353,5984.557,1416.48S5682.1,4908.824,6553.806,5044.3",
    transform: "translate(424.349 762.389)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M75.575-.13C-407.882,1674.082,1541.7,1943.951,2016.1,1461.171c685.509-697.607,3580.033-1694.593,4030.592-73.759S5649.444,4927.726,6521.155,5063.2",
    transform: "translate(399.629 792.955)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M84.067-.144c-514.4,1725,1455,1967.787,1928.308,1483.928C2699.592,781.252,5658.587-262.5,6109.151,1358.333s-492.034,3588.289,379.672,3723.761",
    transform: "translate(374.585 823.525)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M92.866-.16c-545.359,1775.8,1443.86,1991.493,1916.086,1506.559,688.917-707.457,3712.4-1797.975,4162.958-177.142S5585.09,4965.521,6456.8,5100.993",
    transform: "translate(349.237 854.092)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M101.99-.175C-474.317,1826.417,1533.768,2014.118,2005.858,1529.011,2695.074,815.3,5784.44-320.647,6235,1300.183S5553.389,4984.42,6425.1,5119.888",
    transform: "translate(323.561 884.66)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M111.352-.191C-495.906,1877.189,1532.036,2037.85,2003,1551.623c690.971-718.585,3844.763-1901.349,4295.322-280.515s-776.4,3732.2,95.314,3867.674",
    transform: "translate(297.65 915.232)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M120.974-.208c-638.2,1928.177,1409.594,2061.79,1879.429,1574.441C2693.124,850.782,5911.352-378.8,6361.91,1242.031s-871.183,3780.177.523,3915.65",
    transform: "translate(271.476 945.8)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M130.846-.225c-669.161,1978.964,1398.5,2085.534,1867.211,1597.068C2692.525,868.518,5975.182-407.88,6425.745,1212.95S5459.773,5041.1,6331.479,5176.575",
    transform: "translate(245.056 976.373)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M140.952-.242c-700.108,2029.762,1387.409,2109.288,1854.994,1619.7,696.218-733.2,4043.309-2056.414,4493.868-435.58S5429.056,5060,6300.762,5195.473",
    transform: "translate(218.398 1006.941)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M151.285-.26C-579.775,2080.3,1527.6,2132.775,1994.056,1642.067,2692.029,904,6103.549-466.034,6554.108,1154.8S5398.56,5078.9,6270.271,5214.369",
    transform: "translate(191.517 1037.511)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M161.83-.278C-600.177,2131.067,1527.054,2156.506,1992.384,1664.676c699.723-742.937,4175.674-2159.792,4626.237-538.958S5368.287,5097.785,6239.993,5233.257",
    transform: "translate(164.419 1068.085)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M172.583-.3c-792.962,2182.142,1354.13,2180.532,1818.332,1687.581C2692.388,939.477,6232.773-524.19,6683.333,1096.644s-1345.12,4020.037-473.415,4155.509",
    transform: "translate(137.118 1098.655)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M183.529-.315C-640.381,2232.619,1526.568,2203.97,1989.643,1709.9c703.228-752.678,4308.04-2263.165,4758.6-642.332s-1439.909,4068.013-568.2,4203.485",
    transform: "translate(109.62 1129.225)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M194.663-.335C-660.2,2283.392,1526.608,2227.7,1988.556,1732.5,2693.534,974.953,6362.78-582.351,6813.338,1038.483s-1534.7,4115.986-662.986,4251.458",
    transform: "translate(81.938 1159.801)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M205.975-.354C-679.834,2334.165,1526.829,2251.424,1987.649,1755.113c706.729-762.419,4440.409-2366.539,4890.967-745.706S5249.134,5173.364,6120.84,5308.836",
    transform: "translate(54.074 1190.372)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M217.461-.374c-916.764,2385.315,1309.76,2275.53,1769.453,1778.1,708.479-767.294,4506.589-2418.23,4957.152-797.4S5219.793,5192.259,6091.5,5327.727",
    transform: "translate(26.04 1220.943)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M229.107-.394C-718.6,2435.714,1527.777,2298.881,1986.343,1800.328c710.233-772.16,4572.773-2469.917,5023.332-849.084s-1819.059,4259.9-947.353,4395.374",
    transform: "translate(-2.159 1251.519)"
  }))), /*#__PURE__*/React.createElement("rect", {
    className: "f",
    width: 1296,
    height: 885,
    transform: "translate(0 1610)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBg);
export default __webpack_public_path__ + "static/media/bg.1dc65b8d7e35468d203515eb55dd7cec.svg";
export { ForwardRef as ReactComponent };